import { TFunction } from 'i18next'
import z from 'zod'

export const makeBulkCheckoutSchema = (t: TFunction<['packages']>) =>
  z.object({
    comment: z
      .string()
      .max(200, t('packages:bulkCheckoutModal.validation.commentMaxLength'))
      .optional(),
  })
